import axios from 'axios';
import { host_url } from './config';
import { _getFromLocalStorage } from './helpers';

export const POST = async (requestUrl, requestData) => {
  try {
    const requestHeaders = _getFromLocalStorage('requestHeaders');
    if (!requestHeaders) {
      throw new Error('An error occured. Please try again');
    }
    const response = await axios.post(
      `${host_url}${requestUrl}`,
      requestData,
      requestHeaders
    );
    if (response.data.StatusCode === 1) {
      return response.data.Result;
    } else {
      if (
        response.data.ErrorMessage &&
        response.data.ErrorMessage.toLowerCase() !== 'internal server error'
      ) {
        throw new Error(response.data.ErrorMessage);
      } else {
        throw new Error('An error occured. Please try again');
      }
    }
  } catch (error) {
    const errorCode = error && error.response && error.response.status;
    return {
      error: {
        message:
          error.message === 'Network Error'
            ? 'Please check your internet connection and try again'
            : errorCode && errorCode > 300
            ? 'Please try again'
            : error.message,
      },
    };
  }
};

export const GET = async (requestUrl, headerParams) => {
  try {
    let requestHeaders = _getFromLocalStorage('requestHeaders');
    if (!requestHeaders) {
      requestHeaders = { headers: { source: 'PWA' } };
    }
    if (headerParams && headerParams.userId) {
      requestHeaders.headers.UserId = Number(headerParams.userId);
    }

    const response = await axios(`${host_url}${requestUrl}`, requestHeaders);
    if (response.data.StatusCode === 1) {
      return response.data.Result;
    } else {
      if (
        response.data.ErrorMessage &&
        response.data.ErrorMessage.toLowerCase() !== 'internal server error'
      ) {
        throw new Error(response.data.ErrorMessage);
      } else {
        throw new Error('An error occured. Please try again');
      }
    }
  } catch (error) {
    const errorCode = error && error.response && error.response.status;
    return {
      error: {
        message:
          error.message === 'Network Error'
            ? 'Please check your internet connection and try again'
            : errorCode && errorCode > 300
            ? 'Please try again'
            : error.message,
      },
    };
  }
};
